module.exports = __webpack_public_path__ + "static/media/Portrait-10080.21d67492.jpg";